import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { DisclaimerBox } from './components/DisclaimerBox';
import { DiarySection } from './components/DiarySection';
import { ProductReveal } from './components/ProductReveal';
import { ProductExplanation } from './components/ProductExplanation';
import { ExpertQuote } from './components/ExpertQuote';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { TrustBar } from './components/TrustBar';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),
    event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='
    +i+dl;f.parentNode.insertBefore(j,f);})(window,document,
    'script','dataLayer','GTM-KZBZMFT');`;
    document.head.appendChild(script);
  }, []);
  return <div className="min-h-screen flex flex-col w-full bg-cream font-serif text-gray-800" data-id="element-0">
      <Header data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <DisclaimerBox data-id="element-4" />
        <DiarySection data-id="element-5" />
        <ProductReveal data-id="element-6" />
        <ProductExplanation data-id="element-7" />
        <ExpertQuote data-id="element-8" />
        <Testimonials data-id="element-9" />
        <FAQSection data-id="element-10" />
        <TrustBar data-id="element-11" />
        <CTASection data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}